export enum SpecialistAssignmentStrategy {
  ROUND_ROBIN = 'round-robin',
}

export enum BlockPolicy {
  BLOCK = 'block',
  SOFT_BLOCK = 'soft-block',
  NO_BLOCK = 'no-block',
}

export enum PatientLookupIdType {
  SSN = 'ssn',
  SSN_TEST = 'ssn-test',
  NONE = 'none',
}
